<template>
  <div
    class="input-field"
    :class="{'error': validationError}"
  >
    <label v-if="label">{{ label }}</label>

    <div class="custom-select-wrapper w-full">
      <select
        v-model="model"
        class="custom-select"
        :required="required"
      >
        <option
          class="disabled hidden"
          selected
          :value="null"
        >
          Select an Option
        </option>

        <option
          v-if="nullable"
          :value="null"
        />

        <slot>
          <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </slot>
      </select>
    </div>

    <small
      v-if="hint"
      class="text-black"
    >{{ hint }}</small>

    <span
      v-if="validationError"
      class="validation-error-message"
    >
      {{ validationError }}
    </span>
  </div>
</template>

<script setup>

defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  nullable: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
  options: {
    type: Array,
    default: () => [],
  },
  hint: {
    type: String,
    default: '',
  },
});

const model = defineModel();
</script>

<style scoped>
  .custom-select-wrapper {
    position: relative;
    display: inline-block;

    select {
      appearance: none; /* Hide default arrow (WebKit & modern browsers) */
      -webkit-appearance: none;
      -moz-appearance: none;
      padding-right: 2.5rem; /* Leave space for custom arrow */
    }
  }

  .custom-select-wrapper::after {
    content: '';
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    width: 1.25rem;
    height: 1.25rem;
    background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" fill="%23575757" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5"/></svg>');
    background-repeat: no-repeat;
    background-size: contain;
  }
</style>
